<div class="row d-flex justify-content-center align-items-center">
  <div class="col">
    <div [formGroup]="formDataBilling">
      <div class="mt-3">
        <div>
          <h4>Seleccione</h4>
          <mat-radio-group>
            <mat-radio-button
              class="d-block"
              [checked]="typePerson.includes('Persona Física')"
              #fisicPerson
              (change)="changeValueTypePerson('pf')"
              name="typePerson"
              value="Persona Física"
              id="personfisic">
              Persona física
            </mat-radio-button>
            <mat-radio-button
              class="d-block"
              [checked]="typePerson.includes('Persona Moral')"
              #moralPerson
              (change)="changeValueTypePerson('pm')"
              name="typePerson"
              value="Persona Moral"
              id="personmoral">
              Persona moral
            </mat-radio-button>
            <mat-hint fontsize="small" class="ml-1 marginleft" color="red" *ngIf="!typePerson"> El tipo de persona es obligatorio</mat-hint>
          </mat-radio-group>
        </div>

        <mat-form-field class="mt-4" appearance="outline">
          <mat-label>RFC (Registro Federal de Contribuyentes)</mat-label>
          <input matInput formControlName="rfc" />
          <mat-hint color="red" *ngIf="formDataBilling.controls.rfc.errors && formDataBilling.controls.rfc.errors.required"> El RFC es obligatorio.</mat-hint>
          <mat-hint color="red" *ngIf="formDataBilling.controls.rfc.errors && formDataBilling.controls.rfc.errors.rfcInvalido">El RFC no es válido</mat-hint>
        </mat-form-field>
      </div>

      <p class="mt-4">Colocar la razón social sin Régimen Capital (ejemplo: SA de CV) y en mayúsculas, conforme esté registrado en la constancia de situación fiscal.</p>

      <div class="mt-2">
        <mat-form-field appearance="outline">
          <mat-label>Razón social o nombre</mat-label>
          <input matInput formControlName="businessName" (input)="convertirAMayusculas($event)" />
          <mat-hint color="red" *ngIf="formDataBilling.controls.businessName.errors && formDataBilling.controls.businessName.errors.required">
            La razón social es obligatorio.
          </mat-hint>
          <mat-hint color="red" *ngIf="formDataBilling.controls.businessName.errors && formDataBilling.controls.businessName.errors.pattern">
            La razón social debe contener solo letras, números y caracteres especiales.
          </mat-hint>
        </mat-form-field>
      </div>

      <p class="mt-4">Colocar el código postal del domicilio fiscal conforme al registrado en la constancia de situación fiscal.</p>

      <div class="mt-2">
        <mat-form-field>
          <mat-label>Código postal</mat-label>
          <input formControlName="cp" type="text" id="placholderblack" matInput />
          <mat-hint color="red" *ngIf="formDataBilling.get('cp')?.hasError('required')">El código postal es obligatorio.</mat-hint>
          <mat-hint color="red" *ngIf="formDataBilling.get('cp')?.hasError('invalidPostalCode')">El código postal no es válido. Debe tener 5 dígitos.</mat-hint>
        </mat-form-field>
      </div>

      <p class="mt-4">Colocar el régimen fiscal conforme al registrado en la constancia de situación fiscal.</p>

      <div class="mt-2">
        <mat-form-field appearance="outline">
          <mat-label>Régimen físcal</mat-label>
          <mat-select formControlName="taxRegime" (selectionChange)="selectCFDI($event)">
            <mat-option [value]="regimen.id" *ngFor="let regimen of taxRegimeList">{{ regimen.description }}</mat-option>
          </mat-select>
          <mat-hint color="red" *ngIf="formDataBilling.controls.taxRegime.errors && formDataBilling.controls.taxRegime.errors.required">
            El regímen fiscal es obligatorio.</mat-hint
          >
          <mat-hint color="red" *ngIf="formDataBilling.controls.taxRegime.errors && formDataBilling.controls.taxRegime.errors.pattern">
            La razón social debe contener solo letras, números y caracteres especiales.</mat-hint
          >
        </mat-form-field>
        <div class="section-valid reminenvalid">
          <div *ngIf="formDataBilling.controls.taxRegime.errors && formDataBilling.controls.taxRegime.errors.pattern">
            La razón social debe contener solo letras, números y caracteres especiales.
          </div>
        </div>

        <mat-form-field class="mt-4" appearance="outline">
          <mat-label>Uso del CFDI</mat-label>
          <mat-select formControlName="useCFDI">
            <mat-option [value]="use.id" *ngFor="let use of catCFDIList">{{ use.description }}</mat-option>
          </mat-select>
          <mat-hint color="red" *ngIf="formDataBilling.controls.useCFDI.errors && formDataBilling.controls.useCFDI.errors.required">El CFDI es obligatorio.</mat-hint>
        </mat-form-field>
      </div>

      <p>¿Desea que sean sus datos de facturación preferidos?</p>
      <mat-slide-toggle [disabled]="true" (change)="changeValueIsPreferentData($event)" [checked]="true">{{ true ? 'Si' : 'No' }}</mat-slide-toggle>
      <input type="checkbox" name="" id="ispreference" class="d-none" [checked]="isPreferenceDataF" />
    </div>
  </div>
</div>
